const RoundedBlock = (props) => {
	return (
		<div className="block rounded-lg shadow-lg bg-yellow-50 w-11/12 xl:w-4/5 m-auto">
			{props.children}
		</div>
	);
}
 
export default RoundedBlock;